import { READ_WORKED_IN_LAST_30_DAYS_DATA_FAILURE, READ_WORKED_IN_LAST_30_DAYS_DATA_REQUEST, READ_WORKED_IN_LAST_30_DAYS_DATA_SUCCESS, WorkedInLast30DaysActionTypes, WorkedInLast30DaysState } from 'store/reducers/types/workedInLast30Days/workedInLast30Days';

const defaultState: WorkedInLast30DaysState = {
  isLoading: false,
  errorMessage: ""
};

export default function workedInLast30Days(state = defaultState, action: WorkedInLast30DaysActionTypes): WorkedInLast30DaysState {
  switch (action.type) {
    case READ_WORKED_IN_LAST_30_DAYS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_WORKED_IN_LAST_30_DAYS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_WORKED_IN_LAST_30_DAYS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};